import {RouterProps} from "../../../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {
    UiHomeContentSuggestionValueObject
} from "../../../../../data/value-object/ui/UiHomeContentSuggestionValueObject";
import {useEffect} from "react";
import {UiHomeContentSuggestionIO, UiHomeContentSuggestionModificationIO} from "../../../../../io/UiIO";
import {StorageKey} from "../../../../../io/StorageIO";
import {Body1, Caption1Strong, Spinner, Tab} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailTab} from "../../../../DetailViews";
import {
    UiHomeContentSuggestionDescription
} from "../../../../../data/description/ui/UiHomeContentSuggestionDescription";
import {UiHomeContentSuggestionDomain} from "../../../../../data/domain/ui/UiHomeContentSuggestionDomain";
import {
    UiHomeContentSuggestionDescriptor
} from "../../../../../data/descriptor/ui/UiHomeContentSuggestionDescriptor";
import {
    UiHomeContentSuggestionModificationValueObject
} from "../../../../../data/value-object/ui/UiHomeContentSuggestionModificationValueObject";
import {
    UiHomeContentSuggestionModificationSearchOption
} from "../../../../../data/search-option/ui/UiHomeContentSuggestionModificationSearchOption";
import {SearchIndex} from "../../../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../../../ListPageWrapper";
import {
    UiHomeContentSuggestionModificationDescription
} from "../../../../../data/description/ui/UiHomeContentSuggestionModificationDescription";
import {
    UiHomeContentSuggestionModificationDescriptor
} from "../../../../../data/descriptor/ui/UiHomeContentSuggestionModificationDescriptor";
import {Media, MediaFile} from "../../../../Media";

enum Panel {
    Default,
    UiHomeContentSuggestionModificationList
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ uiHomeContentSuggestionId: string }>()
    const item = useStatePair<UiHomeContentSuggestionValueObject | undefined>(undefined)
    const image = useStatePair<MediaFile | undefined>(undefined)

    useEffect(() => {
        if (params.uiHomeContentSuggestionId !== undefined) {
            const id = BigInt(params.uiHomeContentSuggestionId)
            UiHomeContentSuggestionIO
                .getById(id)
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
            MediaFile
                .createFromStorageKey(StorageKey.Ui.Home.Content.suggestion(id))
                .then(image.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('이미지를 찾을 수 없습니다. 이미지를 먼저 수정해주세요.')
                    document.location = document.location.pathname + '/edit'
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && image.value !== undefined && <Page {...props} item={item.value} image={image.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: UiHomeContentSuggestionValueObject
    image: MediaFile
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)

    return <>
        <div className={props.styles.row16}>
            <DetailTab
                {...props}
                panel={panel}>
                <Tab value={Panel.Default}>상세</Tab>
                <Tab value={Panel.UiHomeContentSuggestionModificationList}>수정 이력</Tab>
            </DetailTab>
            <DetailDefaultPanel
                {...props}
                visible={panel.value === Panel.Default}
                client={UiHomeContentSuggestionIO}
                description={UiHomeContentSuggestionDescription}
                properties={props => <PropertyBody {...props} />}
                panelChildren={<>
                    <Caption1Strong>이미지</Caption1Strong>
                    <Media
                        {...props}
                        source={props.image} />
                </>}
                storageKeys={() => StorageKey.Ui.Home.Content.suggestion(props.item.id)} />
            <UiHomeContentSuggestionModificationListPanel
                {...props}
                panel={panel.value} />
        </div>
    </>
}

type PropertyBodyProps = RouterProps & {
    item: UiHomeContentSuggestionDomain
    itemKey: keyof UiHomeContentSuggestionDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "displayOrder":
        case "url":
        case "createdAt":
        case "lastModifiedAt":
            return <Body1>{UiHomeContentSuggestionDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{UiHomeContentSuggestionDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}

type PanelProps = PageProps & {
    panel: Panel
}

function UiHomeContentSuggestionModificationListPanel(props: PanelProps) {
    const modifications = useStatePair<UiHomeContentSuggestionModificationValueObject[]>([])
    const modificationSearchOption: UiHomeContentSuggestionModificationSearchOption = { uiHomeContentSuggestionIdEq: props.item.id }
    const modificationSearchIndex = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {props.panel === Panel.UiHomeContentSuggestionModificationList && <>
            <ListPageWrapper
                {...props}
                client={UiHomeContentSuggestionModificationIO}
                items={modifications}
                option={modificationSearchOption}
                index={modificationSearchIndex}
                description={UiHomeContentSuggestionModificationDescription}
                descriptor={UiHomeContentSuggestionModificationDescriptor} />
        </>}
    </>
}